import { css } from 'lit';
import componentStyles from '../styles/component.styles';
import formStyles from '../styles/forms.styles';
export default css `
${componentStyles}
${formStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
  display: block;
}

/**
--------------------------------------------------
* Rating
--------------------------------------------------
*/
.rating-container {
  display: flex;
  column-gap: 3px;
  unicode-bidi: bidi-override;
}

:host([dark]) {
  color: var(--p-dark-text-color);
}

`;
